const { getCookieValue } = require("./handleCookie");

const getHeaders = () => {
    const headers = {
        'Authorization': `Bearer ${getCookieValue().authToken}`
    };
    return headers;
}
export { getHeaders };